import { BudgetCategory, BudgetSummaryData } from '../types/budget'

export const summaryData: BudgetSummaryData = {
  squareFootage: 1500,
  percentCompleteAfterRough: 62.45,
  softCostPercent: 3.6,
  totalBudget: 361100,
  constructionEscrow: 361100,
}

export const budgetData: BudgetCategory[] = [
  {
    id: 'cat-soft-costs',
    name: 'TOTAL SOFT COSTS',
    totalPercent: 3.6,
    totalBudget: 13000,
    lineItems: [
      {
        id: 'li-sc-1',
        name: 'Architect',
        percentOfBudget: 0.7,
        costPerSqFt: 1.67,
        budgetAmount: 2500,
      },
      {
        id: 'li-sc-2',
        name: 'Engineer',
        percentOfBudget: 0.0,
        costPerSqFt: 0,
        budgetAmount: 0,
      },
      {
        id: 'li-sc-3',
        name: 'Approved Plans',
        percentOfBudget: 1.1,
        costPerSqFt: 2.67,
        budgetAmount: 4000,
      },
      {
        id: 'li-sc-4',
        name: 'Permits',
        percentOfBudget: 1.8,
        costPerSqFt: 4.33,
        budgetAmount: 6500,
      },
    ],
  },
  {
    id: 'cat-demolition',
    name: 'TOTAL DEMOLITION',
    totalPercent: 7.5,
    totalBudget: 27000,
    lineItems: [
      {
        id: 'li-demo-1',
        name: 'Demolition',
        percentOfBudget: 4.2,
        costPerSqFt: 10.13,
        budgetAmount: 15200,
      },
      {
        id: 'li-demo-2',
        name: 'Lot Clearing',
        percentOfBudget: 2.8,
        costPerSqFt: 6.67,
        budgetAmount: 10000,
      },
      {
        id: 'li-demo-3',
        name: 'Dumpster',
        percentOfBudget: 0.5,
        costPerSqFt: 1.2,
        budgetAmount: 1800,
      },
    ],
  },
  {
    id: 'cat-foundation',
    name: 'TOTAL FOUNDATION',
    totalPercent: 15.2,
    totalBudget: 55000,
    lineItems: [
      {
        id: 'li-found-1',
        name: 'Grading',
        percentOfBudget: 0.0,
        costPerSqFt: 0,
        budgetAmount: 0,
      },
      {
        id: 'li-found-2',
        name: 'Foundation',
        percentOfBudget: 15.2,
        costPerSqFt: 36.67,
        budgetAmount: 55000,
      },
      {
        id: 'li-found-3',
        name: 'Excavation',
        percentOfBudget: 0.0,
        costPerSqFt: 0,
        budgetAmount: 0,
      },
      {
        id: 'li-found-4',
        name: 'Inspections',
        percentOfBudget: 0.0,
        costPerSqFt: 0,
        budgetAmount: 0,
      },
    ],
  },
  {
    id: 'cat-framing',
    name: 'TOTAL FRAMING, ROOF, WINDOWS',
    totalPercent: 23.1,
    totalBudget: 83500,
    lineItems: [
      {
        id: 'li-frame-1',
        name: 'Lumber & Framing',
        percentOfBudget: 17.7,
        costPerSqFt: 42.67,
        budgetAmount: 64000,
      },
      {
        id: 'li-frame-2',
        name: 'Roofing',
        percentOfBudget: 2.9,
        costPerSqFt: 7.0,
        budgetAmount: 10500,
      },
      {
        id: 'li-frame-3',
        name: 'Windows & Sliders',
        percentOfBudget: 1.9,
        costPerSqFt: 4.67,
        budgetAmount: 7000,
      },
      {
        id: 'li-frame-4',
        name: 'Siding',
        percentOfBudget: 0.0,
        costPerSqFt: 0,
        budgetAmount: 0,
      },
      {
        id: 'li-frame-5',
        name: 'Gutters',
        percentOfBudget: 0.0,
        costPerSqFt: 0,
        budgetAmount: 0,
      },
      {
        id: 'li-frame-6',
        name: 'Garage Doors',
        percentOfBudget: 0.6,
        costPerSqFt: 1.33,
        budgetAmount: 2000,
      },
    ],
  },
  {
    id: 'cat-plumbing',
    name: 'TOTAL PLUMBING',
    totalPercent: 8.9,
    totalBudget: 32000,
    lineItems: [
      {
        id: 'li-plumb-1',
        name: 'Plumbing Rough-In',
        percentOfBudget: 4.4,
        costPerSqFt: 10.67,
        budgetAmount: 16000,
      },
      {
        id: 'li-plumb-2',
        name: 'HVAC Rough-In',
        percentOfBudget: 3.3,
        costPerSqFt: 8.0,
        budgetAmount: 12000,
      },
      {
        id: 'li-plumb-3',
        name: 'Utility Hook-Ups',
        percentOfBudget: 1.1,
        costPerSqFt: 2.67,
        budgetAmount: 4000,
      },
      {
        id: 'li-plumb-4',
        name: 'Septic',
        percentOfBudget: 0.0,
        costPerSqFt: 0,
        budgetAmount: 0,
      },
      {
        id: 'li-plumb-5',
        name: 'Well',
        percentOfBudget: 0.0,
        costPerSqFt: 0,
        budgetAmount: 0,
      },
      {
        id: 'li-plumb-6',
        name: 'Sprinklers',
        percentOfBudget: 0.0,
        costPerSqFt: 0,
        budgetAmount: 0,
      },
    ],
  },
  {
    id: 'cat-electric',
    name: 'TOTAL ELECTRIC',
    totalPercent: 4.2,
    totalBudget: 15000,
    lineItems: [
      {
        id: 'li-elec-1',
        name: 'Electrical Rough-In',
        percentOfBudget: 4.2,
        costPerSqFt: 10.0,
        budgetAmount: 15000,
      },
    ],
  },
  {
    id: 'cat-interiors',
    name: 'TOTAL INTERIORS',
    totalPercent: 5.0,
    totalBudget: 18000,
    lineItems: [
      {
        id: 'li-int-1',
        name: 'Insulation',
        percentOfBudget: 1.1,
        costPerSqFt: 2.67,
        budgetAmount: 4000,
      },
      {
        id: 'li-int-2',
        name: 'Stairs & Railings',
        percentOfBudget: 0.0,
        costPerSqFt: 0,
        budgetAmount: 0,
      },
      {
        id: 'li-int-3',
        name: 'SheetRock & Tape',
        percentOfBudget: 3.9,
        costPerSqFt: 9.33,
        budgetAmount: 14000,
      },
    ],
  },
  {
    id: 'cat-millwork',
    name: 'TOTAL MILLWORK & DOORS',
    totalPercent: 12.5,
    totalBudget: 45000,
    lineItems: [
      {
        id: 'li-mill-1',
        name: 'Interior Doors',
        percentOfBudget: 1.9,
        costPerSqFt: 4.67,
        budgetAmount: 7000,
      },
      {
        id: 'li-mill-2',
        name: 'Exterior Doors',
        percentOfBudget: 1.7,
        costPerSqFt: 4.0,
        budgetAmount: 6000,
      },
      {
        id: 'li-mill-3',
        name: 'Millwork and Moulding',
        percentOfBudget: 3.3,
        costPerSqFt: 8.0,
        budgetAmount: 12000,
      },
      {
        id: 'li-mill-4',
        name: 'Masonry',
        percentOfBudget: 5.5,
        costPerSqFt: 13.33,
        budgetAmount: 20000,
      },
    ],
  },
  {
    id: 'cat-flooring',
    name: 'TOTAL FLOORING',
    totalPercent: 3.9,
    totalBudget: 14000,
    lineItems: [
      {
        id: 'li-floor-1',
        name: 'Wood Flooring',
        percentOfBudget: 0.0,
        costPerSqFt: 0,
        budgetAmount: 0,
      },
      {
        id: 'li-floor-2',
        name: 'Tile Flooring',
        percentOfBudget: 0.0,
        costPerSqFt: 0,
        budgetAmount: 0,
      },
      {
        id: 'li-floor-3',
        name: 'Carpet Flooring',
        percentOfBudget: 0.0,
        costPerSqFt: 0,
        budgetAmount: 0,
      },
      {
        id: 'li-floor-4',
        name: 'LVP Flooring',
        percentOfBudget: 0.0,
        costPerSqFt: 0,
        budgetAmount: 0,
      },
      {
        id: 'li-floor-5',
        name: 'Finish Flooring',
        percentOfBudget: 3.9,
        costPerSqFt: 9.33,
        budgetAmount: 14000,
      },
    ],
  },
  {
    id: 'cat-kitchen-baths',
    name: 'TOTAL KITCHEN & BATHS',
    totalPercent: 5.8,
    totalBudget: 21100,
    lineItems: [
      {
        id: 'li-kb-1',
        name: 'Kitchen Cabinets',
        percentOfBudget: 1.7,
        costPerSqFt: 4.0,
        budgetAmount: 6000,
      },
      {
        id: 'li-kb-2',
        name: 'Bathroom Vanities',
        percentOfBudget: 0.8,
        costPerSqFt: 2.0,
        budgetAmount: 3000,
      },
      {
        id: 'li-kb-3',
        name: 'Toilets, Sinks, Bathtubs, Shower',
        percentOfBudget: 0.7,
        costPerSqFt: 1.73,
        budgetAmount: 2600,
      },
      {
        id: 'li-kb-4',
        name: 'Countertops',
        percentOfBudget: 1.4,
        costPerSqFt: 3.33,
        budgetAmount: 5000,
      },
      {
        id: 'li-kb-5',
        name: 'Appliances',
        percentOfBudget: 1.2,
        costPerSqFt: 3.0,
        budgetAmount: 4500,
      },
      {
        id: 'li-kb-6',
        name: 'Tiling',
        percentOfBudget: 0.0,
        costPerSqFt: 0,
        budgetAmount: 0,
      },
    ],
  },
  {
    id: 'cat-finishings',
    name: 'TOTAL FINISHINGS',
    totalPercent: 10.4,
    totalBudget: 37500,
    lineItems: [
      {
        id: 'li-fin-1',
        name: 'Painting Interior',
        percentOfBudget: 2.5,
        costPerSqFt: 6.0,
        budgetAmount: 9000,
      },
      {
        id: 'li-fin-2',
        name: 'Painting Exterior',
        percentOfBudget: 1.0,
        costPerSqFt: 2.33,
        budgetAmount: 3500,
      },
      {
        id: 'li-fin-3',
        name: 'Finish Electrical Light Fixtures',
        percentOfBudget: 1.9,
        costPerSqFt: 4.67,
        budgetAmount: 7000,
      },
      {
        id: 'li-fin-4',
        name: 'Fencing',
        percentOfBudget: 0.0,
        costPerSqFt: 0,
        budgetAmount: 0,
      },
      {
        id: 'li-fin-5',
        name: 'Sidewalk, Parking, Driveway',
        percentOfBudget: 2.2,
        costPerSqFt: 5.33,
        budgetAmount: 8000,
      },
      {
        id: 'li-fin-6',
        name: 'Landscaping',
        percentOfBudget: 1.9,
        costPerSqFt: 4.67,
        budgetAmount: 7000,
      },
      {
        id: 'li-fin-7',
        name: 'Front Finish',
        percentOfBudget: 0.0,
        costPerSqFt: 0,
        budgetAmount: 0,
      },
      {
        id: 'li-fin-8',
        name: 'Pool/ Hot Tub',
        percentOfBudget: 0.0,
        costPerSqFt: 0,
        budgetAmount: 0,
      },
      {
        id: 'li-fin-9',
        name: 'Porch/Deck',
        percentOfBudget: 0.0,
        costPerSqFt: 0,
        budgetAmount: 0,
      },
      {
        id: 'li-fin-10',
        name: 'HVAC',
        percentOfBudget: 0.8,
        costPerSqFt: 2.0,
        budgetAmount: 3000,
      },
      {
        id: 'li-fin-11',
        name: 'Elevator, Fireplace, Epoxy',
        percentOfBudget: 0.0,
        costPerSqFt: 0,
        budgetAmount: 0,
      },
      {
        id: 'li-fin-12',
        name: 'Generator',
        percentOfBudget: 0.0,
        costPerSqFt: 0,
        budgetAmount: 0,
      },
      {
        id: 'li-fin-13',
        name: 'Final Inspections or Certificate of Occupancy',
        percentOfBudget: 0.0,
        costPerSqFt: 0,
        budgetAmount: 0,
      },
    ],
  },
]
